import React from 'react';

const SectionHeader = ({ 
  title, 
  subtitle, 
  className = "text-center mb-12" 
}) => {
  return (
    <div className={className}>
      <h2 className="text-3xl md:text-4xl font-bold text-orange-800 mb-4">{title}</h2>
      {subtitle && (
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-4xl mx-auto">
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeader;
